export default "\nuniform vec3 diffuse;\nuniform vec3 mColor, jColor;\n\nvarying float vLineDistance;\n\n#include <common>\n#include <color_pars_fragment>\n\nvarying float vAlpha, vDepth;\nvarying vec2 vUv;\n\nuniform float t;\n\nvoid main() {\n  if(vUv.x >= t) discard;\n\n  vec4 diffuseColor = vec4(diffuse, vAlpha);\n\n  #include <color_fragment>\n\n  // if(dot(diffuseColor.rgb, jColor.rgb) > 0.9) discard; // test\n\n  gl_FragColor = vec4( diffuseColor.rgb, diffuseColor.a );\n}"


//////////////////
// WEBPACK FOOTER
// ./src/assets/shaders/sbp/sbp.frag
// module id = oqs3
// module chunks = 1